'use client';

import { Content } from '@prismicio/client';
import { Simplify } from '../../../../prismicio-types';

import styles from './rateCalculatorInner.module.scss';
import { Calculator, Container } from '@/components';
import { RateCalculatorTextContent } from '.';
import { CalculatorProps } from '@/types';
import { useVisible } from '@/hooks';

interface RateCalculatorInnerProps {
  data: Simplify<Content.RateCalculatorSliceDefaultPrimary>;
}

export const RateCalculatorInner = ({ data }: RateCalculatorInnerProps) => {
  const [isVisible, id] = useVisible();

  const calculatorProps: CalculatorProps = {
    buttonLink: data.button_link,
    buttonText: data.button_text,
    defaultValue: data.default_value,
    max: data.max_value,
    min: data.min_value,
    rateText: data.rate_text,
    rateValue: data.rate_value,
    resultText: data.result_text,
    step: data.step,
    timeLineText: data.time_line_text,
    timeLineValue: data.time_line_value,
    title: data.calculator_title,
    plateText: data.apply_text,
    illustrativeText: data.illustrative_text,
    rangeHeading: data.range_heading,
    buttonVariation: 'blue',
    variation: 'medium',
  };

  return (
    <Container styles={styles.container} id={id}>
      <div className={styles.column}>
        <Calculator data={calculatorProps} />
      </div>
      <RateCalculatorTextContent
        title={data.title}
        subtitle={data.subtitle}
        advantagesHeading={data.advantages_heading}
        advantages={data.advantages}
        isVisible={isVisible}
      />
    </Container>
  );
};
